import * as tslib_1 from "tslib";
import setTableIsInCheckedMode from './mutators/setTableIsInCheckedMode';
import setFocusedRowKey from './mutators/setFocusedRowKey';
import updateVirtualSelectAllExclusionList from './mutators/updateVirtualSelectAllExclusionList';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import { setSelectionOnRow } from 'owa-mail-actions/lib/mailListSelectionActions';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { action } from 'satcheljs/lib/legacy';
export default action('toggleSelectRowInternal')(function toggleSelectRowInternal(tableView, rowKey, isUserNavigation, mailListItemSelectionSource) {
    var isCheckboxSelect = mailListItemSelectionSource == MailListItemSelectionSource.MailListItemCheckbox;
    var isTargetRowSelected = tableView.selectedRowKeys.has(rowKey);
    // If this was a checkbox select on an existing selected item and the table is not in checked mode,
    // just enter checked mode. No other selection state should change.
    if (isTargetRowSelected && !tableView.isInCheckedMode && isCheckboxSelect) {
        setTableIsInCheckedMode(tableView, true);
        return;
    }
    // If the table currently has a single item selected (and non-checked) and we're clicking checkbox to select
    // another item, we want to unselect the existing selected item first
    if (tableView.selectedRowKeys.size == 1 &&
        !tableView.isInCheckedMode &&
        !isTargetRowSelected &&
        isCheckboxSelect) {
        setSelectionOnRow(tslib_1.__spread(tableView.selectedRowKeys.keys())[0], tableView.id, false /* shouldSelect */);
    }
    // Proceed with toggling selection on the target row
    var shouldSelect = !isTargetRowSelected;
    if (shouldSelect && !tableView.isInCheckedMode) {
        setTableIsInCheckedMode(tableView, true);
    }
    if (tableView.isInVirtualSelectAllMode) {
        updateVirtualSelectAllExclusionList(tableView, rowKey);
    }
    else {
        if (isMailFeatureEnabled('tri-selectionRefactor')) {
            setSelectionOnRow(rowKey, tableView.id, shouldSelect /* shouldSelect */);
        }
        else {
            updateSelectionOnRow(tableView, rowKey, shouldSelect, isUserNavigation, mailListItemSelectionSource);
        }
    }
});
function updateSelectionOnRow(tableView, rowKey, shouldSelect, isUserNavigation, mailListItemSelectionSource) {
    if (shouldSelect) {
        setSelectionOnRow(rowKey, tableView.id, true /* shouldSelect */);
        // Set the selection anchor for possible future shift-selection
        setFocusedRowKey(tableView, rowKey);
    }
    else {
        setSelectionOnRow(rowKey, tableView.id, false /* shouldSelect */);
        // Set the selection anchor for possible future shift-selection
        var selectionAnchor = tableView.selectedRowKeys.size > 0
            ? tslib_1.__spread(tableView.selectedRowKeys.keys())[tableView.selectedRowKeys.size - 1]
            : null;
        setFocusedRowKey(tableView, selectionAnchor);
    }
}
//# sourceMappingURL=toggleSelectRowInternal.js.map